import React, { useState, useEffect, useMemo } from 'react';
import { FormatCategoryName, clearFiltersFromSession } from '../../../utils';
import { useDetectClickOutsideElement } from '../../../hooks/useDetectClickOutsideElement';

function ModalFilterCategory({ category, providers, applyFilter, clearFilter, closeModal, activeModal }) {
  const [stateCategory, setStateCategory] = useState(category);
  const [stateProvider, setStateProvider] = useState(providers);

  const { containerRef } = useDetectClickOutsideElement({ onClickOutside: closeModal, enabled: activeModal });

  const toggleOptionFilter = (type, categoryIndex, optionIndex = 0) => {
    if (type === 'provider') {
      const updatedProviders = [...stateProvider];
      updatedProviders[categoryIndex].selected = !updatedProviders[categoryIndex].selected;
      setStateProvider(updatedProviders);
    } else if (type === 'category') {
      const updatedCategories = [...stateCategory];
      updatedCategories[categoryIndex].Categories[optionIndex].selected =
        !updatedCategories[categoryIndex].Categories[optionIndex].selected;
      setStateCategory(updatedCategories);
    }
  };

  const getIconPath = (selected) =>
    selected ? '/assets/images/check_dark_green.svg' : '/assets/images/checkbox-uncheked.svg';

  useEffect(() => {
    setStateCategory(category);
    setStateProvider(providers);
  }, [category, providers]);

  const BenefitsFilters = useMemo(() => {
    const benefitCategory = stateCategory.find((cat) => cat.ID === BENEFIT_CATEGORY_ID);

    if (!benefitCategory) return null;

    return (
      <div className="divider">
        <span className="category-title">{benefitCategory.Name}</span>
        {benefitCategory.Categories.map((option, optionIndex) => (
          <div
            key={optionIndex}
            className="option-item"
            onClick={() => toggleOptionFilter('category', 3, optionIndex)}
            data-cy={`filtro-${FormatCategoryName(benefitCategory.Name)}-${optionIndex}`}
          >
            <img src={getIconPath(option.selected)} alt="check-box" />
            <span className="option-filter-item">{option.Name}</span>
          </div>
        ))}
      </div>
    );
  }, [stateCategory]);

  return (
    <div className={`comp_modalpagamento mobile-roof filter${!activeModal ? ' hide-comp-modal' : ''}`}>
      <div className="modalcontents filter" ref={containerRef}>
        <div className="contents">
          <div className="modaltop filter">
            <div className="title white">
              <img src="/assets/images/icons/filter_white.svg" alt="icone filtro" className="icon-filtro" />
              Filtros
            </div>
            <div onClick={() => {
              closeModal();
            }} className="close-btn" data-cy="botao-fechar-filtro">
              <img src="/assets/images/close_white.svg" alt="close modal" />
            </div>
          </div>

          <div className="modalmiddle wrap noBorder">
            <ul className="lista-categorias-filtro">
              <div className="lista-categorias-filtro-left">
                {stateCategory.map(
                  (cat, categoryIndex) =>
                    cat.ID !== BENEFIT_CATEGORY_ID && (
                      <div key={categoryIndex} className={`cat${cat.ID} ${categoryIndex > 0 ? 'divider' : ''}`}>
                        <span className="category-title">{cat.Name}</span>
                        {cat.Categories.map((option, optionIndex) => (
                          <div
                            key={optionIndex}
                            className="option-item"
                            onClick={() => toggleOptionFilter('category', categoryIndex, optionIndex)}
                            data-cy={`filtro-${FormatCategoryName(cat.Name)}-${optionIndex}`}
                          >
                            <img src={getIconPath(option.selected)} alt="check-box" />
                            <span className="option-filter-item">{option.Name}</span>
                          </div>
                        ))}
                      </div>
                    )
                )}

                {BenefitsFilters}
              </div>

              <div className="lista-categorias-filtro-right">
                <div className="divider">
                  <span className="category-title">Seguradoras</span>
                  <div className="option-itembox">
                    {stateProvider.map((provider, index) => (
                      <div
                        key={index}
                        className="option-item"
                        onClick={() => toggleOptionFilter('provider', index)}
                        data-cy={`filtro-seguradora-${provider.slug}`}
                      >
                        <img src={getIconPath(provider.selected)} alt="uncheked" />
                        <span className="option-filter-item">{provider.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </ul>
          </div>

          <div className="modalfooter filter">
            <ul className="buttons-lista-modal">
              <li>
                <button className="btn-filter-limpar" onClick={() => {
                  clearFiltersFromSession();
                  clearFilter();
                }} data-cy="botao-limpar-filtro">
                  Limpar filtros
                </button>
              </li>
              <li>
                <button className="btn-filter-aplicar" onClick={() => {
                  applyFilter();
                }} data-cy="botao-aplicar-filtro">
                  Aplicar filtros
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

const BENEFIT_CATEGORY_ID = 6;

export default ModalFilterCategory;



// WEBPACK FOOTER //
// ./src/components/search/modal_filter_category/ModalFilterCategory.jsx